var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalBarchart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.5C3.55228 2.5 4 2.94772 4 3.5L4 20.5C4 21.0523 3.55229 21.5 3 21.5C2.44772 21.5 2 21.0523 2 20.5L2 3.5C2 2.94772 2.44772 2.5 3 2.5ZM6.06667 6.03333C6.06667 4.92876 6.9621 4.03333 8.06667 4.03333H20C21.1046 4.03333 22 4.92876 22 6.03333V9.1C22 10.2046 21.1046 11.1 20 11.1H8.06667C6.9621 11.1 6.06667 10.2046 6.06667 9.1V6.03333ZM20 6.03333L8.06667 6.03333V9.1H20L20 6.03333ZM6.06667 14.9C6.06667 13.7954 6.9621 12.9 8.06667 12.9H16.2C17.3046 12.9 18.2 13.7954 18.2 14.9V17.9667C18.2 19.0712 17.3046 19.9667 16.2 19.9667H8.06667C6.9621 19.9667 6.06667 19.0712 6.06667 17.9667V14.9ZM16.2 14.9H8.06667V17.9667H16.2V14.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarchart);
export default __webpack_public_path__ + "static/media/horizontal_barchart.196bc77f404e8505c71278e37cde3694.svg";
export { ForwardRef as ReactComponent };